const categoryBanners = {
  education: {
    category: 'Education',
    copy: 'Search for schools and educational programs, scholarships and grants for women'
  },
  health: {
    category: 'Health & Wellness',
    copy: 'Explore the many services available to help women survive and thrive'
  },
  entertainment: {
    category: 'Entertainment',
    copy: 'Discover films, art, music, travel and fun activities just for women'
  },
  money: {
    category: 'Money',
    copy: 'Search for money management and planning advice'
  },
  work: {
    category: 'Work',
    copy: 'Find job boards, career advice, and multitudes of associations and networks to join'
  },
  entrepreneurs: {
    category: 'Entrepreneurs',
    copy: 'Explore categories for funding, training, and networking to start and grow a business'
  },
  'womens-rights': {
    category: "Women's Rights",
    copy: 'Tap into the many organizations and services dedicated to protecting and empowering women around the world'
  },
  motherhood: {
    category: 'Motherhood',
    copy: 'Find services and programs to support pregnancy, birth and parenting'
  },
  girls: {
    category: "Girls' Rights",
    copy: 'Discover organizations, programs and services dedicated to promoting and protecting the rights of girls around the world'
  },
  invest: {
    category: 'Invest',
    copy: 'Explore the many ways that you can invest in women-owned businesses to help them grow and thrive'
  },
  'global-crises': {
    category: 'Global Crises',
    copy: 'Find organizations that respond to humanitarian crises and fight injustices around the world'
  },
};

export default categoryBanners;



// WEBPACK FOOTER //
// ./src/misc/categoryLandingBanners.js